import { Popover } from "@mui/material"
import { format } from "date-fns"
import Icon from "@/components/icon/Icon"
import type { Activity } from "@/types/activity"
import { getActivityColor } from "@/app/activity/list/utils"
import "./activityDayPopover.scss"

interface ActivityDayPopoverProps {
  open: boolean
  // anchorEl 또는 anchorPosition 중 하나만 있으면 됨. 둘 다 있으면 anchorPosition 우선.
  anchorEl?: HTMLElement | null
  anchorPosition?: { top: number; left: number }
  date: Date | null
  activities: Activity[]
  onClose: () => void
  onActivityClick: (activity: Activity, anchorEl: HTMLElement) => void
}

export default function ActivityDayPopover({
  open,
  anchorEl,
  anchorPosition,
  date,
  activities,
  onClose,
  onActivityClick,
}: ActivityDayPopoverProps) {
  if (!date) {
    return null
  }

  return (
    <Popover
      open={open}
      anchorReference={anchorPosition ? "anchorPosition" : "anchorEl"}
      anchorEl={anchorPosition ? null : anchorEl}
      anchorPosition={anchorPosition}
      onClose={onClose}
      anchorOrigin={{ vertical: "top", horizontal: "left" }}
      transformOrigin={{ vertical: "top", horizontal: "left" }}
      slotProps={{ paper: { sx: { borderRadius: "10px" } } }}>
      <div className="ActivityDayPopover">
        <div className="ActivityDayPopover__header">
          <div className="ActivityDayPopover__heading">
            <span className="ActivityDayPopover__weekday">{format(date, "EEE").toUpperCase()}</span>
            <span className="ActivityDayPopover__day">{format(date, "d")}</span>
          </div>
          <button className="ActivityDayPopover__close" aria-label="Close" onClick={onClose}>
            <Icon type="close" size={20} />
          </button>
        </div>
        <div className="ActivityDayPopover__list">
          {activities.length === 0 && (
            <div className="ActivityDayPopover__empty">No activities</div>
          )}
          {activities.map((activity) => (
            <button
              key={activity.idfActivity}
              className="ActivityDayPopover__item"
              onClick={(e) => onActivityClick(activity, e.currentTarget)}>
              <span
                className="ActivityDayPopover__dot"
                style={{ background: getActivityColor(activity.type) }}
              />
              <span className="ActivityDayPopover__name">{activity.name}</span>
            </button>
          ))}
        </div>
      </div>
    </Popover>
  )
}
